import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';  
import Header from'../Component/Header'
const VissionMission = () => {  
  useEffect(() => {
    document.title = 'Vission and Mission - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li>Vission and Mission</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2> Our Vision, Aim and Objectives </h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                        <p>The aim of the school is to impart quality education designed for the all-round development of the child. The students will be prepared for their future duties by a careful cultivation of their minds and hearts. Children will be enlightened intellectually morally, socially, professionally and spiritually. Although it is a Christian Minority school, every student is encouraged to practice his/her religion. Special emphasis is given for the practice of natural virtues like universal brotherhood, truthfulness, honesty, politeness, tolerance, simplicity, self-discipline and orderliness.</p>
                     </div>
                </div> 
            </div>
        </div>
     </>
  )
}

export default VissionMission

